module.exports = "/_next/static/images/14805a6e2c987dfd508d127461834966-ticket-02-02.png.webp";